import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { getCookie } from "../config/webStorage";
import { apiurl } from "../config/config";
import dayjs from "dayjs";
import { useUser } from "../config/userProvider";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CreateBatchPage = () => {
  const { userData } = useUser();
  const navigation = useNavigate();
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [search, setSearch] = useState("");
  const [description, setDescription] = useState("");

  // 🔹 Filters
  const [statusFilter, setStatusFilter] = useState("");
  //   const [joiningDate, setJoiningDate] = useState("");
  const [joiningDate, setJoiningDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // gives YYYY-MM-DD format
  });

  const [trainingFilter, setTrainingFilter] = useState("");

  const token = getCookie("swtoken");

  // 🔹 Fetch Applications
  const fetchApplications = async (queryObj = {}) => {
    try {
      const res = await axios.post(
        `${apiurl}/api/application/search`,
        queryObj,
        {
          headers: { Authorization: `${token}` },
        }
      );
      setApplications(res.data.data || []);
      setFilteredApplications(res.data.data || []);
    } catch (err) {
      console.error("Error fetching applications:", err);
    }
  };

  // Initial load
//   useEffect(() => {
//     fetchApplications({
//       applicationStatus: statusFilter,
//       joiningDate: joiningDate,
//     });
//   }, [token]);

  // 🔹 Search & Filter
  const handleSearch = () => {
    let query = {};

    // Search by name/email/applicationId
    if (search) {
      query.$or = [
        { "candidateSnapshot.firstName": { $regex: search, $options: "i" } },
        { "candidateSnapshot.lastName": { $regex: search, $options: "i" } },
        { "candidateSnapshot.email": { $regex: search, $options: "i" } },
        { "candidateSnapshot.phone": { $regex: search, $options: "i" } },
        { id: { $regex: search, $options: "i" } },
      ];
    }

    if (statusFilter) {
      query.applicationStatus = statusFilter;
    }

    if (joiningDate) {
      query["offerDetails.joiningDate"] = joiningDate;
    }

    if (trainingFilter) {
      query.trainingStatus = trainingFilter;
    }

    fetchApplications(query);
  };

  // 🔹 Toggle application selection
  const toggleSelect = (app) => {
    if (selectedApplications.find((a) => a._id === app._id)) {
      setSelectedApplications(
        selectedApplications.filter((a) => a._id !== app._id)
      );
    } else {
      setSelectedApplications([...selectedApplications, app]);
    }
  };

  // 🔹 Submit batch
  const handleCreateBatch = async () => {
    if (selectedApplications.length === 0) {
      alert("Please select applications.");
      return;
    }

    try {
      const res = await axios.post(
        `${apiurl}/api/batch/create`,
        {
          creatorObjId: userData?._id,
          applications: selectedApplications.map((a) => a._id),
          description,
        },
        {
          headers: { Authorization: `${token}` },
        }
      );
      //   alert("Batch created successfully!");
      toast.success("Batch created successfully!");
      navigation(`/batches/${res?.data?.batch?._id}/manage`);
      console.log(res.data);
      setDescription("");
      setSelectedApplications([]);
    } catch (err) {
      console.error("Error creating batch:", err);
      alert("Error creating batch.");
    }
  };

  // 🔹 Remove app from selected team
  const removeFromSelected = (appId) => {
    setSelectedApplications(
      selectedApplications.filter((a) => a._id !== appId)
    );
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold mb-4">Create New Batch</h1>

          {/* Batch Form */}
          <div className="bg-white shadow rounded-lg p-4 mb-6">
            <label className="block mb-2 font-medium">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description..."
              className="w-full border p-2 rounded mb-4"
            />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block mb-2 font-medium">Batch Date</label>
                <input
                  type="text"
                  value={dayjs().format("DD MMM YYYY")}
                  readOnly
                  className="w-full border p-2 rounded bg-gray-100 cursor-not-allowed"
                />
              </div>

              {/* Created By */}
              <div className="mb-4">
                <label className="block mb-2 font-medium">Created By</label>
                <input
                  type="text"
                  value={
                    userData?.firstName + " " + userData?.lastName ||
                    "Unknown User"
                  }
                  readOnly
                  className="w-full border p-2 rounded bg-gray-100 cursor-not-allowed capitalize"
                />
              </div>
            </div>

            {/* Selected Summary */}
            {/* Selected Summary */}
            {selectedApplications.length > 0 && (
              <div className="my-2 bg-gray-100 p-4 rounded-lg">
                <h2 className="font-semibold my-2">
                  Selected Applications ({selectedApplications.length})
                </h2>
                <table className="w-full text-sm border">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="p-2 border">ID</th>
                      <th className="p-2 border">Name</th>
                      <th className="p-2 border">Email</th>
                      <th className="p-2 border">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedApplications.map((a) => (
                      <tr key={a._id}>
                        <td className="p-2 border">{a.id}</td>
                        <td className="p-2 border">
                          {a.candidateSnapshot.firstName}{" "}
                          {a.candidateSnapshot.lastName}
                        </td>
                        <td className="p-2 border">
                          {a.candidateSnapshot.email}
                        </td>
                        <td className="p-2 border text-center">
                          <button
                            onClick={() => removeFromSelected(a._id)}
                            className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded"
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <button
              onClick={handleCreateBatch}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow"
            >
              Create Batch
            </button>
          </div>

          {/* Search & Filters */}
          <div className="bg-white shadow p-4 rounded-lg mb-4 grid grid-cols-1 md:grid-cols-5 gap-4">
            <input
              type="text"
              placeholder="Search by name/email/phone/applicationId"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border p-2 rounded"
            />

            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="border p-2 rounded"
            >
              <option value="">--Select Status--</option>
              <option value="offered">Offered</option>
              <option value="selected">Selected</option>
              <option value="joined">Joined</option>
              <option value="rejected">Rejected</option>
              <option value="pending">Pending</option>
            </select>

            <input
              type="date"
              value={joiningDate}
              onChange={(e) => setJoiningDate(e.target.value)}
              className="border p-2 rounded"
            />

            <select
              value={trainingFilter}
              onChange={(e) => setTrainingFilter(e.target.value)}
              className="border p-2 rounded"
            >
              <option value="">All Training</option>
              <option value="completed">Completed</option>
              <option value="ongoing">Ongoing</option>
              <option value="not_started">Not Started</option>
            </select>

            <button
              onClick={handleSearch}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded shadow"
            >
              Search
            </button>
          </div>

          {/* Active Filters Display */}
          <div className="flex flex-wrap gap-2 mb-4">
            {search && (
              <span className="bg-gray-200 px-3 py-1 rounded-full text-sm">
                Search: {search}
              </span>
            )}
            {statusFilter && (
              <span className="bg-green-200 px-3 py-1 rounded-full text-sm">
                Status: {statusFilter}
              </span>
            )}
            {joiningDate && (
              <span className="bg-blue-200 px-3 py-1 rounded-full text-sm">
                Joining: {dayjs(joiningDate).format("DD MMM YYYY")}
              </span>
            )}
            {trainingFilter && (
              <span className="bg-purple-200 px-3 py-1 rounded-full text-sm">
                Training: {trainingFilter}
              </span>
            )}
          </div>

          {/* Applications List */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredApplications.map((app) => {
              const selected = selectedApplications.find(
                (a) => a._id === app._id
              );
              return (
                <div
                  key={app._id}
                  className={`p-4 border rounded-lg shadow-sm cursor-pointer ${
                    selected ? "bg-green-100 border-green-400" : "bg-white"
                  }`}
                  onClick={() => toggleSelect(app)}
                >
                  <h2 className="font-bold">
                    {app.candidateSnapshot.firstName +
                      " " +
                      app.candidateSnapshot.lastName}{" "}
                    ({app.id})
                  </h2>
                  <p className="text-sm">{app.candidateSnapshot.email}</p>
                  <p className="text-sm">{app.candidateSnapshot.phone}</p>

                  {app.offerDetails?.joiningDate && (
                    <p className="text-sm text-gray-600">
                      Joining Date:{" "}
                      {dayjs(app.offerDetails.joiningDate).format(
                        "DD MMM YYYY"
                      )}
                    </p>
                  )}

                  <span
                    className={`inline-block mt-2 px-2 py-1 text-xs rounded ${
                      selected ? "bg-green-600 text-white" : "bg-gray-200"
                    }`}
                  >
                    {selected ? "Selected" : "Click to Select"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default CreateBatchPage;